module.exports = __webpack_public_path__ + "static/img/8.282f076.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/8.png
// module id = AHdX
// module chunks = 0